export type ProjectOverviewColumnKey =
  | 'client'
  | 'lastViewedAt'
  | 'status'
  | 'notebook'
  | 'noOfItems'
  | 'estimate'
  | 'invoice'
  | 'installDate'
  | 'customColumn1'
  | 'customColumn2'
  | 'customColumn3';

export type ProjectOverviewColumnVisibility = Partial<Record<ProjectOverviewColumnKey, boolean>>;

export const PROJECT_OVERVIEW_COLUMNS: { key: ProjectOverviewColumnKey; label: string }[] = [
  { key: 'client', label: 'Client/Project' },
  { key: 'lastViewedAt', label: 'Last Viewed' },
  { key: 'status', label: 'Project Status' },
  { key: 'notebook', label: 'Notebook' },
  { key: 'noOfItems', label: 'No. of Items' },
  { key: 'estimate', label: 'Estimate' },
  { key: 'invoice', label: 'Invoice' },
  { key: 'installDate', label: 'Install Date' },
  { key: 'customColumn1', label: 'Custom Field 1' },
  { key: 'customColumn2', label: 'Custom Field 2' },
  { key: 'customColumn3', label: 'Custom Field 3' },
];

export const DEFAULT_PROJECT_OVERVIEW_COLUMN_VISIBILITY: Record<ProjectOverviewColumnKey, boolean> = {
  client: true,
  lastViewedAt: true,
  status: true,
  notebook: true,
  noOfItems: true,
  estimate: true,
  invoice: true,
  installDate: true,
  customColumn1: false,
  customColumn2: false,
  customColumn3: false,
};

export const resolveColumnVisibility = (
  visibility?: ProjectOverviewColumnVisibility
): Record<ProjectOverviewColumnKey, boolean> => ({
  ...DEFAULT_PROJECT_OVERVIEW_COLUMN_VISIBILITY,
  ...(visibility ?? {}),
});

export const isColumnVisible = (
  visibility: ProjectOverviewColumnVisibility | undefined,
  key: ProjectOverviewColumnKey
): boolean => visibility?.[key] !== false;
